import React from 'react';
import { Paginator } from 'primereact/paginator';

const MembersPaginationControls = ({
  page,
  pageSize,
  totalCount,
  totalPages,
  pageSizeOptions,
  onPageChange,
}) => {
  const safePage = Number(page || 0);
  const safePageSize = Number(pageSize || 50);
  const safeTotalCount = Number(totalCount || 0);
  const safeTotalPages = Number(totalPages || 0);
  const isEmpty = safeTotalPages === 0;
  const displayPage = isEmpty ? 0 : safePage + 1;
  const first = safePage * safePageSize;

  const handlePageChange = (event) => {
    if (isEmpty) {
      onPageChange({ page: 0, rows: safePageSize, first: 0 });
      return;
    }

    onPageChange(event);
  };

  const template = {
    layout: 'RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink',
  };

  return (
    <div className="mt-3">
      <div className="flex align-items-center justify-content-between flex-wrap gap-3 mb-2">
        <div>{`${safeTotalCount} members`}</div>
        <div>{`Page ${displayPage} of ${safeTotalPages}`}</div>
      </div>

      <Paginator
        first={isEmpty ? 0 : first}
        rows={safePageSize}
        totalRecords={safeTotalCount}
        rowsPerPageOptions={pageSizeOptions}
        onPageChange={handlePageChange}
        template={template}
      />
    </div>
  );
};

export default MembersPaginationControls;